import type {
  EntryCollection,
  ContentfulClientApi,
  EntrySkeletonType,
} from 'contentful';
import { getDeliveryClient, getStagingClient } from './ContentfulConfig';
import { EnvironmentVariables } from '../../utils/environment/Environment.model';
import environment from '../../utils/environment';

export const fetchEntriesByType = async <
  TFields extends Record<string, unknown> = Record<string, unknown>,
>(
  contentTypeId: string,
  query: Record<string, unknown> = {},
): Promise<EntryCollection<EntrySkeletonType<TFields>> | null> => {
  console.log('\n🔄 fetchEntriesByType called with:', {
    contentTypeId,
    query: JSON.stringify(query, null, 2),
  });

  const usePreview =
    environment.get(EnvironmentVariables.ENVIRONMENT, 'Staging') === 'Staging';

  let client: ContentfulClientApi<undefined> | null = null;

  if (usePreview) {
    client = getStagingClient();
    if (!client) {
      console.warn(
        '⛔ Contentful Staging Client requested (staging environment) but not available/initialized.',
      );
      return null;
    }
  } else {
    client = getDeliveryClient();
    if (!client) {
      console.warn(
        '⛔ Contentful Delivery Client requested (prod environment) but not available/initialized.',
      );
      return null;
    }
  }

  try {
    const finalQuery = {
      content_type: contentTypeId,
      include: 1,
      ...query,
    };
    const entries =
      await client.getEntries<EntrySkeletonType<TFields>>(finalQuery);

    return entries;
  } catch (error: unknown) {
    const err = error as Error;
    console.error('Error details:', {
      message: err.message,
      stack: err.stack,
    });
    return null;
  }
};
